import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaArrowRight } from 'react-icons/fa';
import './Documentation.css';

function Documentation() {
  const text = "Mpesa, Website, Mailer, Sms";
  const [displayedText, setDisplayedText] = useState("");
  const [charIndex, setCharIndex] = useState(0);

  useEffect(() => {
    if (charIndex < text.length) {
      const timeout = setTimeout(() => {
        setDisplayedText(text.substring(0, charIndex + 1)); // Fix duplication issue
        setCharIndex(charIndex + 1);
      }, 100);
      return () => clearTimeout(timeout);
    }
  }, [charIndex, text]);

  return (
    <div className="documentation">
      <h1>Welcome to the Muindi Documentation</h1>
      <p className="typing-text">{displayedText}</p>

      <div className="language-links">
      <Link to="/languages/PHP" className="doc-link">
  <span>PHP</span> <FaArrowRight className="icon" />
</Link>

        <Link to="/languages/Python" className="doc-link">
          <span>Python</span> <FaArrowRight className="icon" />
        </Link>

        <Link to="/languages/Javascript" className="doc-link">
          <span>JavaScript</span> <FaArrowRight className="icon" />
        </Link>
      </div>
    </div>
  );
}


export default Documentation;
